import { auth } from '../firebase/firebaseApp';

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

export async function changeUserPasswordAsAdmin(
  targetUid: string,
  newPassword: string
): Promise<ChangePasswordResponse> {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('Debes haber iniciado sesión como Administrador.');
  }

  const idToken = await currentUser.getIdToken(true);

  const response = await fetch('/api/admin/users/change-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({
      requesterUid: currentUser.uid,
      targetUid,
      newPassword,
    }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Error al cambiar la contraseña del usuario.');
  }

  return data;
}
